import { z } from "zod";
import {
  PHONE_1,
  PHONE_2,
  ACCOUNT_NUMBER,
  BANK_NAME,
  CURRENCY,
  LEASE_DUE_DATE,
  MONTHLY_DUE_DATE,
  ROUTING_NUMBER,
  YEARLY_DUE_DATE,
  REPORTING_LEVEL,
  DISTRIBUTION_MODE,
  FREQUENCY_FOR_ACTUALS,
  ACTUALS_DAY_OF_MONTH,
  ACTUALS_DATE,
  ACTUALS_DATE_Q1,
  ACTUALS_DATE_Q2,
  ACTUALS_DATE_Q3,
  ACTUALS_DATE_Q4,
} from "./consts";

const optionalDateField = z
  .union([
    z.string().refine((val) => !val || !isNaN(Date.parse(val)), {
      message: "Invalid date format",
    }),
    z.date(),
  ])
  .optional();

export const financeSchema = z.object({
  [YEARLY_DUE_DATE]: optionalDateField,
  [MONTHLY_DUE_DATE]: z.string().optional(),
  [LEASE_DUE_DATE]: optionalDateField,
  [CURRENCY]: z.string().optional(),
  [BANK_NAME]: z.string().optional(),
  [ROUTING_NUMBER]: z.string().optional(),
  [ACCOUNT_NUMBER]: z.string().optional(),
  [PHONE_1]: z.string().optional(),
  [PHONE_2]: z.string().optional(),
  [REPORTING_LEVEL]: z.string().optional(),
  [DISTRIBUTION_MODE]: z.string().optional(),
  [FREQUENCY_FOR_ACTUALS]: z.string().optional(),
  [ACTUALS_DAY_OF_MONTH]: z.string().optional(),
  [ACTUALS_DATE]: optionalDateField,
  [ACTUALS_DATE_Q1]: optionalDateField,
  [ACTUALS_DATE_Q2]: optionalDateField,
  [ACTUALS_DATE_Q3]: optionalDateField,
  [ACTUALS_DATE_Q4]: optionalDateField,
});

export type financeFormValues = z.infer<typeof financeSchema>;
